import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

const fetchFieldActivityPlan = async (lng = "english", params = {}) => {
  try {
    const user = await getStorage();
    const res = await api({
      method: "GET",
      url: `${API_URL}/fieldActivityPlan`,
      params,
      headers: { Authorization: `Bearer ${user.token}` },
    });
    return res.data;
  } catch (error) {
    toastMessage("error", "Unable to fetch field activity plan");
  }
};

export const createFieldActivityPlan = async (lng = "english", body) => {
  const user = await getStorage();
  return api({
    method: "POST",
    url: `${API_URL}/fieldActivityPlan`,
    data: body,
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export const bulkCreateFieldActivityPlan = async (lng = "english", entries) => {
  const user = await getStorage();
  return api({
    method: "POST",
    url: `${API_URL}/fieldActivityPlan/bulk`,
    data: { entries },
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export const updateFieldActivityPlan = async (lng = "english", body) => {
  const user = await getStorage();
  return api({
    method: "PUT",
    url: `${API_URL}/fieldActivityPlan`,
    data: body,
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export const recordFieldActivityPerformance = async (lng = "english", body) => {
  const user = await getStorage();
  return api({
    method: "PUT",
    url: `${API_URL}/fieldActivityPlan/perform`,
    data: body,
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export const deleteFieldActivityPlan = async (lng = "english", id) => {
  const user = await getStorage();
  return api({
    method: "DELETE",
    url: `${API_URL}/fieldActivityPlan`,
    data: { id },
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export default fetchFieldActivityPlan;
